// src/services/payment.service.js
import { baseApi } from './base.api';
import { API_CONFIG } from '../config/api.config';

class PaymentService {
  pay(amount, athleteId) {
    return baseApi.post(API_CONFIG.ENDPOINTS.PAYMENT.PAY, {
      amount,
      athleteId,
    });
  }

  getPayments(params = {}) {
    let url = API_CONFIG.ENDPOINTS.PAYMENT.SHOW;
    if (params && Object.keys(params).length > 0) {
      const qs = Object.keys(params)
        .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&');
      url = `${url}?${qs}`;
    }
    return baseApi.get(url);
  }

  deletePayment(id) {
    return baseApi.delete(API_CONFIG.ENDPOINTS.PAYMENT.DELETE(id));
  }
}

export const paymentService = new PaymentService();
